import React from 'react';
import styled from 'styled-components';
import Dropdown from 'react-simple-dropdown';

import { Icon, GLYPHS } from 'components/Shared/Icon';
import { SCAFFOLDING, TRANSITION, SELECTS, MAPTOOLBAR } from 'theme';

const DropdownToggle = styled.button`
    height: ${MAPTOOLBAR.BUTTON.HEIGHT};
    padding-left: ${SELECTS.PADDING.X};
    padding-right: ${SELECTS.PADDING.X};
    background-color: transparent;
    border: 0;
    color: #666;
    text-align: right;

    svg {
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        transition: transform ${TRANSITION.LENGTH} ${TRANSITION.BEZIER};
    }

    .dropdown--active & svg {
        transform: scale(1, -1);
    }
`;

const DropdownToggleLabel = styled.span`
    display: inline-block;
    width: 2.75em;
    line-height: 1;
    vertical-align: middle;
`;

const DropdownContent = styled.div`
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    min-width: 100%;
    max-width: 30em;
    margin-bottom: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    z-index: 1;
    overflow: hidden;
    background-color: ${SCAFFOLDING.BG};
    box-shadow: ${SCAFFOLDING.BOX_SHADOW.HOVER};
    border-radius: ${SCAFFOLDING.BORDER_RADIUS};

    /* TODO: Add proper animation while making sure it does not take space while closed */

    .dropdown--active & {
        display: block;
    }
`;

const DropdownItem = styled.button`
    display: block;
    width: 100%;
    padding: ${SELECTS.OPTION.PADDING.Y} ${SELECTS.OPTION.PADDING.X};
    background-color: transparent;
    border: 0;
    text-align: left;
    white-space: nowrap;

    &:hover,
    &:focus {
        background-color: ${SELECTS.OPTION.HOVER_BG};
    }
`;

class MapToolbarDropdown extends React.Component {
    handleToggleClick = () => {
        const dropdown = this.zoomDropdown;
        if (dropdown.isActive()) {
            dropdown.hide();
        } else {
            dropdown.show();
        }
    };

    render() {
        const { previewZoom, onFitToScreen, onChangePreviewZoom, ...props } = this.props;
        return (
            <Dropdown
                ref={(el) => {
                    this.zoomDropdown = el;
                }}
                {...props}
            >
                <DropdownToggle type="button" onClick={this.handleToggleClick} {...props}>
                    <DropdownToggleLabel>{parseInt(Math.round(previewZoom * 100), 10)}%</DropdownToggleLabel>
                    <Icon glyph={GLYPHS.CARET_DOWN} />
                </DropdownToggle>
                <DropdownContent>
                    <DropdownItem type="button" onClick={(e) => onFitToScreen(e)}>
                        Fit to screen
                    </DropdownItem>
                    <DropdownItem type="button" onClick={() => onChangePreviewZoom(1)}>
                        100%
                    </DropdownItem>
                    <DropdownItem type="button" onClick={() => onChangePreviewZoom(0.75)}>
                        75%
                    </DropdownItem>
                    <DropdownItem type="button" onClick={() => onChangePreviewZoom(0.5)}>
                        50%
                    </DropdownItem>
                    <DropdownItem type="button" onClick={() => onChangePreviewZoom(0.25)}>
                        25%
                    </DropdownItem>
                </DropdownContent>
            </Dropdown>
        );
    }
}

export default MapToolbarDropdown;
